import { render, staticRenderFns } from "./HouseFundGeneralInfo.vue?vue&type=template&id=4bdbf95d&"
import script from "./HouseFundGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./HouseFundGeneralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports